(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["franklen-home-redesign"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fh-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('.fh-hero-slide'));
    const dots = Array.from(carousel.querySelectorAll('[data-fh-dot]'));
    const previous = carousel.querySelector('[data-fh-prev]');
    const next = carousel.querySelector('[data-fh-next]');
    let activeIndex = 0;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        if (dotIndex === activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => showSlide(Number(dot.dataset.fhDot)));
    });
    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    showSlide(0);
  });

  document.querySelectorAll('.franklen-home').forEach((home) => {
    const revealItems = Array.from(home.querySelectorAll('.fh-hero-copy, .fh-media, .fh-section, .fh-card, .fh-brand-card, .fh-cta'));

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    revealItems.forEach((item, index) => {
      item.classList.add('fh-reveal');
      item.style.setProperty('--fh-reveal-index', index % 6);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });

    revealItems.forEach((item) => observer.observe(item));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franklen-industrial-hero"] && !Shopify.designMode) return;
  try {
    
  class FranklenHeroCarousel {
    constructor(hero) {
      this.hero = hero;
      this.slides = Array.from(hero.querySelectorAll('[data-franklen-slide]'));
      this.dots = Array.from(hero.querySelectorAll('[data-franklen-dot]'));
      this.current = 0;
      this.interval = null;

      if (this.slides.length < 2) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.show(index);
          this.start();
        });
      });

      this.start();
    }

    show(index) {
      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current].classList.remove('is-active');
      this.current = index;
      this.slides[this.current].classList.add('is-active');
      this.dots[this.current].classList.add('is-active');
    }

    start() {
      window.clearInterval(this.interval);
      this.interval = window.setInterval(() => {
        const next = (this.current + 1) % this.slides.length;
        this.show(next);
      }, 6000);
    }
  }

  document.querySelectorAll('[data-franklen-hero]').forEach((hero) => new FranklenHeroCarousel(hero));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-exploded-diagram"] && !Shopify.designMode) return;
  try {
    
  class ExplodedDiagram extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-part-dialog]');
      this.panels = Array.from(this.querySelectorAll('[data-part-panel]'));
      this.hotspots = Array.from(this.querySelectorAll('[data-hotspot]'));
      this.rows = Array.from(this.querySelectorAll('[data-part-row]'));
      this.tabs = Array.from(this.querySelectorAll('[data-diagram-tab]'));
      this.pages = Array.from(this.querySelectorAll('[data-diagram-page]'));
      this.search = this.querySelector('[data-part-search]');
      this.activePageIndex = this.tabs[0]?.dataset.diagramTab || '1';

      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => this.openPart(hotspot));
        hotspot.addEventListener('mouseenter', () => this.setActive(hotspot));
      });

      this.rows.forEach((row) => {
        row.addEventListener('click', () => this.openPart(row));
        row.addEventListener('mouseenter', () => this.setActive(row));
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setDiagramPage(tab.dataset.diagramTab));
      });

      this.querySelector('[data-close-dialog]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.querySelectorAll('[data-ajax-cart-form]').forEach((form) => {
        form.addEventListener('submit', (event) => this.addToCart(event));
      });

      this.search?.addEventListener('input', () => this.filterParts());
      this.setDiagramPage(this.activePageIndex);
    }

    getPartGroup(trigger) {
      return trigger?.dataset.partGroup || trigger?.dataset.partId || '';
    }

    setActive(trigger) {
      const partGroup = this.getPartGroup(trigger);
      this.hotspots.forEach((hotspot) => {
        hotspot.toggleAttribute('aria-current', this.getPartGroup(hotspot) === partGroup);
      });
      this.rows.forEach((row) => {
        row.toggleAttribute('aria-current', this.getPartGroup(row) === partGroup);
      });
    }

    openPart(trigger) {
      const partGroup = this.getPartGroup(trigger);
      const matchingPanels = this.panels.filter((panel) => this.getPartGroup(panel) === partGroup);
      if (!matchingPanels.length) return;

      this.setActive(trigger);
      this.panels.forEach((panel) => {
        panel.hidden = this.getPartGroup(panel) !== partGroup;
      });
      if (!this.dialog.open) this.dialog.showModal();
    }

    setDiagramPage(pageIndex) {
      this.activePageIndex = pageIndex || '1';
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.diagramTab === this.activePageIndex;
        tab.setAttribute('aria-selected', String(isActive));
      });
      this.pages.forEach((page) => {
        page.hidden = page.dataset.diagramPage !== this.activePageIndex;
      });
      this.hotspots.forEach((hotspot) => {
        hotspot.removeAttribute('aria-current');
      });
      this.rows.forEach((row) => {
        row.removeAttribute('aria-current');
      });
      this.panels.forEach((panel) => {
        panel.hidden = true;
      });
      this.filterParts();
    }

    filterParts() {
      const query = this.search.value.trim().toLowerCase();
      this.rows.forEach((row) => {
        const pageMatches = !row.dataset.diagramPageIndex || row.dataset.diagramPageIndex === this.activePageIndex;
        const queryMatches = query.length === 0 || row.dataset.searchText.includes(query);
        row.hidden = !pageMatches || !queryMatches;
      });
    }

    async addToCart(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button[type="submit"]');
      const message = form.parentElement.querySelector('[data-cart-message]');
      const formData = new FormData(form);

      button.disabled = true;
      message.textContent = '';
      message.removeAttribute('data-state');

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);

        message.textContent = this.dataset.addedText;
        message.dataset.state = 'success';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: result } }));
      } catch (error) {
        message.textContent = error.message || this.dataset.errorText;
        message.dataset.state = 'error';
      } finally {
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('exploded-diagram')) {
    customElements.define('exploded-diagram', ExplodedDiagram);
  }


  } catch(e) { console.error(e); }
})();
})();
